/**
 * OpenAPI definition
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * Current user.
 */
export interface UserDto {
  id: number;
  login: string;
  role: UserDto.RoleEnum;
  subRole?: UserDto.SubRoleEnum;
  active: boolean;
  accountId?: number;
  enabled2FA: boolean;
  forceToResetPassword: boolean;
  firstName?: string;
  lastName?: string;
  lastPasswordChange?: string;
  /**
   * True if the user signs in with google single sign-on only.
   */
  ssoOnly: boolean;
}
export namespace UserDto {
  export const RoleEnum = {
    Admin: 'ADMIN',
    Client: 'CLIENT',
    ClientApiKey: 'CLIENT_API_KEY',
    AdminRead: 'ADMIN_READ',
    SuperAdmin: 'SUPER_ADMIN',
    AdminCompliance: 'ADMIN_COMPLIANCE',
  } as const;
  export type RoleEnum = (typeof RoleEnum)[keyof typeof RoleEnum];
  export const SubRoleEnum = {
    ReadOnly: 'READ_ONLY',
    Trader: 'TRADER',
    TraderPro: 'TRADER_PRO',
  } as const;
  export type SubRoleEnum = (typeof SubRoleEnum)[keyof typeof SubRoleEnum];
}
